<template>
  <div class="h-full p-6">
    <div
      class="flex h-full items-center justify-center rounded-xl p-6"
      :class="[{ 'bg-bg-1': bg }]"
    >
      <div class="flex max-w-[224px] flex-col items-center">
        <img
          class="mb-[11px] h-[120px] w-[160px]"
          :src="EmptyState"
          alt="Empty"
        />
        <div
          class="mb-[3px] text-center text-[19px] font-semibold text-gpx_black-500"
        >
          {{ title }}
        </div>
        <div class="mb-[26px] text-center text-[15px] text-gpx_gray-300">
          {{ subtitle }}
        </div>
        <slot />
      </div>
    </div>
  </div>
</template>

<script setup>
import EmptyState from '@/assets/empty-state.svg';

defineProps({
  title: {
    type: String,
    default: '',
  },
  subtitle: {
    type: String,
    default: '',
  },
  bg: {
    type: Boolean,
    default: true,
  },
});
</script>
